<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <!-- Кузов -->
    <rect
      x="1"
      y="3"
      width="13"
      height="13"
      :stroke="stroke"
      stroke-width="2"
    />
    <!-- Кабина (короче кузова, с лобовым стеклом) -->
    <path
      d="M14 8h5l4 4v4h-9V8z"
      :stroke="stroke"
      stroke-width="2"
      stroke-linejoin="round"
    />
    <!-- Заднее колесо (под кузовом) -->
    <circle cx="5" cy="18" r="2" :stroke="stroke" stroke-width="2" />
    <!-- Переднее колесо (под кабиной) -->
    <circle cx="19" cy="18" r="2" :stroke="stroke" stroke-width="2" />
  </svg>
</template>

<script>
export default {
  name: "TruckIcon",

  props: {
    size: {
      type: [Number, String],
      default: 20,
    },
    stroke: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>
